import React, {
  ComponentType,
  FunctionComponent,
  ReactElement,
  useEffect,
} from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { connect, ConnectedProps } from 'react-redux';
import { PrivateRoute } from './components';
import { ApplicationState } from './redux/States';
import { AuthDispatches, ErrorDispatches } from './redux/Dispatches';
import Apis from './apis';
import { ToastContainer } from 'react-toastify';

import './custom.scss';
import 'react-toastify/dist/ReactToastify.min.css';
import { MenuItem } from './model';
import { HomePage } from './pages/HomePage';
import { LoadingPage } from './pages/Loading';
import { LoginPage } from './pages/Login';
import { NotFound } from './pages/NotFound';
import { BasicClassStudent } from './pages/BasicClassStudent';
import { StudentFindByName } from './pages/StudentFindByName';
import { ImportStudentPage } from './pages/ImportStudent';
import { UpdateStudentPage } from './pages/UpdateStudent';
import { SchoolInfo } from './pages/SchoolInfo';
import { ClassesSetting } from './pages/ClassesSetting';
import { ClassPHIWHPage } from './pages/ClassPHIWHPage';
import { ClassPHIWHSightPage } from './pages/ClassPHIWHSightPage';
import { ClassPHISightPage } from './pages/ClassPHISightPage';
import { ClassPHITeePage } from './pages/ClassPHITeePage';
import { ChangeClassPage } from './pages/ChangeClassPage';
import { ImportPhiWHPage } from './pages/ImporPhiWH';
import { ImportPhiSightPage } from './pages/ImportPhiSight';
import { ImportPhiSundryPage } from './pages/ImportPhiSundry';
import { ImportPhiLabPage } from './pages/ImportPhiLab';
import { ImportPhiPhysicalPage } from './pages/ImportPhiPhysical';
import {
  ImportPhiBloodPage,
  ImportPhiXRayPage,
  ImportPhiWHSightPage,
  ImportDiseasePage,
} from './pages/Imports';
import { StudentPHIPage, GraduatedStudentPHIPage } from './pages/StudentPHIs';
import { ImportPhiTeePage } from './pages/ImportPhiTee';
import {
  SolidPDFPage,
  SightPDFPage,
  TeeUnPassPDFPage,
  WHClassListPDFPage,
} from './pages/PDFs';
import { DocPage } from './pages/DocPage';
import { NoticePage } from './pages/Notice';
import { TransferOutPage, TransferInPage, Retention } from './pages/Transfer';
import { PhysicalSettingPage } from './pages/PhysicalSettingPage';
import {
  CheckTempInput,
  CheckTempRep,
  CheckBloodStastic,
  CheckStastic,
  CheckXRayStastic,
  CheckHealthCard,
  CheckAllQuery,
  CheckNoteSel,
  HealthExaminationRecord,
} from './pages/Notice/CheckTemp';
import { Disease, SeriousCard, BodyMindBookN } from './pages/InputData';
import { LabSemPage } from './pages/LabSemPage';
import { InjuryPage } from './pages/InjuryPage';
import { FluorSetting, CleanSet } from './pages/Tee';
import {
  SightNoDiagNotice,
  SightLongDilation,
  SightShortDilation,
  SightDilatingNear,
  SightOddNotice,
  Sight0RankNotice,
  SightSchool,
  SightDilated,
  SightClassNotice,
  SightSolid,
  SightClassCorrect,
  SightClassUnCorrect,
  SightCorrect,
  SightUnCorrect,
  SightStaticRate2,
  SightStatic,
  SightDiagrate2,
  SightDilatingNearRate,
  SightLongDilationRate,
  SightShortDilationRate,
  SightDeteriorateRate,
  SightIncreasedShort,
  SightHightNear,
  SightDiagMatrix,
  SightUnCheck,
  SightCantCheck,
  SightUnCorrectChart,
  SightStatisticChart,
  SightSimple,
} from './pages/Notice/Sight';
import {
  WHClassStatistic,
  WHClassList,
  WHClassAvg,
  WHDeskMaxtrix,
  WHClassSight,
  WHSchoolSight,
  WHList,
  WHClassBmi,
  WHGradeStatistic,
  WHUnCheck,
  WHCantCheck,
  WHIncressedHeight,
  WHHeightChart,
  WHWeightChart,
  WHBmiChart,
  WHSightClassList,
  WHBelowGHD,
} from './pages/Notice/WH';
import {
  TeeStaticSexNeatInit,
  TeeClassStaticSexNeatInit,
  TeeStaticSexNeat,
  TeeClassStaticSexNeat,
  TeeStaticSexAll,
  TeeClassStatic,
  TeeStatic,
  TeeStaticSex,
  TeeFluorStaticGrade,
  TeeFluorStaticClass,
  TeeCleanStaticGrade,
  TeeCleanStaticClass,
  TeeUnCheck,
  TeeImplTable,
} from './pages/Notice/Teeth';
import { HospitalPage } from './pages/HospitalPage';
import {
  DiseaseClass,
  DiseaseGrade,
  DiseaseClassBodyMind,
  DiseaseKind,
  DiseaseStaticChart,
} from './pages/Notice/Disease';
import {
  InjuryAccList,
  InjuryClassAccList,
  InjuryAccStCount,
  InjuryAccListSortByClass,
  InjuryAccListSortByDate,
  InjuryAccStaticChart,
  InjuryAccStaticMonthChart,
} from './pages/Notice/Injury';
import { OtherStCount, Aborigine } from './pages/Notice/Other';
import { NameList } from './pages/Note';
import { ExportStudent } from './pages/ExportStudent';
import { ClassPHISimpleSightPage } from './pages/ClassPHISimpleSightPage';
import { OTPPage } from './pages/OTPPage';

const mapState = (state: ApplicationState) => ({
  ...state.auth,
});
const mapDispatch = { ...AuthDispatches, ...ErrorDispatches };
const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;

const urlPageMap: {
  [k: string]: ComponentType<any> | undefined;
} = {
  '/students': BasicClassStudent,
  '/studentfindbyname': StudentFindByName,
  '/import/student': ImportStudentPage,
  '/import/update/student': UpdateStudentPage,
  '/school': SchoolInfo,
  '/classes/setting': ClassesSetting,
  '/class/phi/wh': ClassPHIWHPage,
  '/class/phi/whsight': ClassPHIWHSightPage,
  '/class/phi/sight': ClassPHISightPage,
  '/class/phi/sight/nocheck': ClassPHISimpleSightPage,
  '/class/phi/tee': ClassPHITeePage,
  '/class/change': ChangeClassPage,
  '/import/phi/wh': ImportPhiWHPage,
  '/import/phi/sight': ImportPhiSightPage,
  '/import/phi/sundry': ImportPhiSundryPage,
  '/import/phi/lab': ImportPhiLabPage,
  '/import/phi/physical': ImportPhiPhysicalPage,
  '/import/phi/blood': ImportPhiBloodPage,
  '/import/phi/xray': ImportPhiXRayPage,
  '/import/phi/whsight': ImportPhiWHSightPage,
  '/import/disease': ImportDiseasePage,
  '/student/phi': StudentPHIPage,
  '/student/graduated/phi': GraduatedStudentPHIPage,
  '/import/phi/tee': ImportPhiTeePage,
  '/notices/solid': SolidPDFPage,
  '/notices/sight': SightPDFPage,
  '/notices/tee': TeeUnPassPDFPage,
  '/notices/whclasslist': WHClassListPDFPage,
  '/doc': DocPage,
  '/notice': NoticePage,
  '/transfer/out': TransferOutPage,
  '/transfer/in': TransferInPage,
  '/settings/physical': PhysicalSettingPage,
  '/checktemp/class/input': CheckTempInput,
  '/inputdata/disease': Disease,
  '/inputdata/seriouscard': SeriousCard,
  '/inputdata/bodymindbookn': BodyMindBookN,
  '/settings/labsem': LabSemPage,
  '/injury': InjuryPage,
  '/tee/fluor/setting': FluorSetting,
  '/tee/clean/cleanset': CleanSet,
  '/notice/sight/nodiag': SightNoDiagNotice,
  '/notice/sight/longdilation': SightLongDilation,
  '/notice/sight/shortdilation': SightShortDilation,
  '/notice/sight/dilatingnear': SightDilatingNear,
  '/notice/sight/odd': SightOddNotice,
  '/notice/sight/0rank': Sight0RankNotice,
  '/notice/sight/school': SightSchool,
  '/notice/sight/sightdilated': SightDilated,
  '/notice/sight/class': SightClassNotice,
  '/notice/sight/solid': SightSolid,
  '/notice/sight/classcorrect': SightClassCorrect,
  '/notice/sight/classuncorrect': SightClassUnCorrect,
  '/notice/sight/sightcorrect': SightCorrect,
  '/notice/sight/sightuncorrect': SightUnCorrect,
  '/notice/sight/staticrate2': SightStaticRate2,
  '/notice/sight/static': SightStatic,
  '/notice/sight/sightdiagrate2': SightDiagrate2,
  '/notice/sight/sightdilatingnearate': SightDilatingNearRate,
  '/notice/sight/sightlongdilationrate': SightLongDilationRate,
  '/notice/sight/sightshortdilationrate': SightShortDilationRate,
  '/notice/sight/sightdeterioraterate': SightDeteriorateRate,
  '/notice/sight/sightincreasedshort': SightIncreasedShort,
  '/notice/sight/sighthightnear': SightHightNear,
  '/notice/sight/sightdiagmatrix': SightDiagMatrix,
  '/notice/sight/sightuncheck': SightUnCheck,
  '/notice/sight/sightcantcheck': SightCantCheck,
  '/notice/sight/sightuncorrectchart': SightUnCorrectChart,
  '/notice/sight/sightstatisticchart': SightStatisticChart,
  '/notice/sight/sightsimple': SightSimple,
  '/notice/wh/class/statistic': WHClassStatistic,
  '/notices/wh/class/list': WHClassList,
  '/notice/check/checktemprep': CheckTempRep,
  '/notice/check/checkbloodstastic': CheckBloodStastic,
  '/notice/check/checkstastic': CheckStastic,
  '/notice/check/checkxraystastic': CheckXRayStastic,
  '/notice/check/checkhealthcard': CheckHealthCard,
  '/notice/check/checkallquery': CheckAllQuery,
  '/notice/check/checknotesel': CheckNoteSel,
  '/notice/wh/class/avg': WHClassAvg,
  '/notice/wh/deskmaxtrix': WHDeskMaxtrix,
  '/notice/wh/class/sight': WHClassSight,
  '/notice/wh/school/sight': WHSchoolSight,
  '/notice/wh/whlist': WHList,
  '/notice/wh/class/bmi': WHClassBmi,
  '/notice/wh/grade/statistic': WHGradeStatistic,
  '/notice/wh/whuncheck': WHUnCheck,
  '/notice/wh/whcantcheck': WHCantCheck,
  '/notice/wh/whincressedheight': WHIncressedHeight,
  '/notice/wh/whheightchart': WHHeightChart,
  '/notice/wh/whweightchart': WHWeightChart,
  '/notice/wh/whbmichart': WHBmiChart,
  '/notices/wh/whsightclasslist': WHSightClassList,
  '/notices/wh/whbelowghd': WHBelowGHD,
  '/notice/teeth/teestaticsexneatinit': TeeStaticSexNeatInit,
  '/notice/teeth/teeclassstaticsexneatinit': TeeClassStaticSexNeatInit,
  '/notice/teeth/teestaticsexneat': TeeStaticSexNeat,
  '/notice/teeth/teeclassstaticsexneat': TeeClassStaticSexNeat,
  '/notice/teeth/teestaticsexall': TeeStaticSexAll,
  '/notice/teeth/teestatic': TeeClassStatic,
  '/notice/teeth/teeclassstatic': TeeStatic,
  '/notice/teeth/teestaticsex': TeeStaticSex,
  '/notice/teeth/teefluorstaticgrade': TeeFluorStaticGrade,
  '/notice/teeth/teefluorstaticclass': TeeFluorStaticClass,
  '/notice/teeth/teecleanstaticgrade': TeeCleanStaticGrade,
  '/notice/teeth/teecleanstaticclass': TeeCleanStaticClass,
  '/notice/teeth/teeuncheck': TeeUnCheck,
  '/notice/teeth/teeimpltable': TeeImplTable,
  '/settings/hospital': HospitalPage,
  '/notice/disease/diseaseclass': DiseaseClass,
  '/notice/disease/diseasegrade': DiseaseGrade,
  '/notice/disease/diseaseclassbodymind': DiseaseClassBodyMind,
  '/notice/disease/diseasekind': DiseaseKind,
  '/notice/disease/diseasestaticchart': DiseaseStaticChart,
  '/notice/injury/injuryacclist': InjuryAccList,
  '/notice/injury/injuryclassacclist': InjuryClassAccList,
  '/notice/injury/injuryaccstcount': InjuryAccStCount,
  '/notice/injury/injuryacclistsortbyclass': InjuryAccListSortByClass,
  '/notice/injury/injuryacclistsortbydate': InjuryAccListSortByDate,
  '/notice/injury/injuryaccstaticchart': InjuryAccStaticChart,
  '/notice/injury/injuryaccstaticmonthchart': InjuryAccStaticMonthChart,
  '/notice/other/otherstcount': OtherStCount,
  '/notice/other/aborigine': Aborigine,
  '/notice/other/healthexaminationrecord': HealthExaminationRecord,
  '/retention': Retention,
  '/note/namelist': NameList,
  '/export/student': ExportStudent,
};

const reduceToRoute = (menus: MenuItem[]) => {
  return menus.reduce((pv, cv) => {
    const page = urlPageMap[cv.url?.toLocaleLowerCase() ?? ''];
    if (page && cv.url) {
      const Page = page;
      pv.push(
        <PrivateRoute
          key={cv.url}
          exact
          path={cv.url.toLocaleLowerCase()}
          render={(props) => <Page {...props} />}
        />
      );
    }
    if (cv.children) {
      pv = pv.concat(reduceToRoute(cv.children));
    }
    return pv;
  }, [] as ReactElement[]);
};

export const app: FunctionComponent<Props> = ({
  isAuth,
  user,
  loading,
  checkAuth,
  catchErrorForModal,
  signOut,
}) => {
  function activeTimeoutCallback() {
    signOut().catch(() => {});
  }
  useEffect(() => {
    checkAuth().catch((e) => {
      Apis.updateCacheToken('token');
      catchErrorForModal(e);
    });
    Apis.registerActiveTimeout(activeTimeoutCallback);
  }, []);

  const qs = new URLSearchParams(window.location.search);
  const lastPath = qs.get('lastPath') || '/';
  if (typeof isAuth === 'undefined' || loading) {
    return (
      <React.Fragment>
        <LoadingPage />
      </React.Fragment>
    );
  }
  if (isAuth && !user.currentSchool) {
    return (
      <React.Fragment>
        <Switch>
          <Route exact={true} path="/otp" component={OTPPage} />
          <Redirect from="*" to="/otp" />
        </Switch>
      </React.Fragment>
    );
  }
  if (!isAuth || !user) {
    return (
      <React.Fragment>
        <Switch>
          <Route exact={true} path="/login" component={LoginPage} />
          <Redirect from="*" to="/login" />
        </Switch>
      </React.Fragment>
    );
  }
  const { menus } = user;
  const rountes = reduceToRoute(menus);
  return (
    <React.Fragment>
      <Switch>
        <Redirect from="/login" to={lastPath} />
        <Redirect from="/otp" to={lastPath} />
        {rountes}
        <PrivateRoute exact={true} path="/" component={HomePage} />
        <Route path="*" component={NotFound} />
      </Switch>
      <ToastContainer autoClose={5000} pauseOnHover newestOnTop />
      <div id="root-portal"></div>
    </React.Fragment>
  );
};
document.documentElement.lang = 'zh-tw';

export const App = connector(app);
